import React from "react";
import { ColoredSlider } from "../Sliders";
import { Grid } from "@material-ui/core";

const SafetySliders = (props) => {
    const {fields, handleChange} = props;

    return(
        <Grid container justifyContent="center" style={{width: "70%"}} className='index2'>
            {fields.map((field) => (
                <Grid item xs={11} key={field.name}>
                    <ColoredSlider 
                        key = {field.name}
                        name={field.name}
                        value={field.value}
                        onChange={handleChange} 
                    />
                </Grid>
            ))}
        </Grid>
    )
}
export default SafetySliders;